import { numberFromStringSchema, FormInitializerReturnType } from 'src/Configuration/validation'
import {
  DynamicPricesModel,
  DynamicPricesSettings,
  PRICE_FALLBACK_NO_DEC,
  PRICE_FALLBACK_THREE_DEC,
  PRICE_FALLBACK_TWO_DEC,
  ReferencePriceModel,
} from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { array, boolean, number, object } from 'yup'

const fallbackFormValues: DynamicPricesSettings = {
  energyPriceSurcharge: PRICE_FALLBACK_TWO_DEC,
  networkFees: PRICE_FALLBACK_THREE_DEC,
  taxes: PRICE_FALLBACK_THREE_DEC,
  dynamicPricesForWallboxesEnabled: false,
  priceLimitWallbox: PRICE_FALLBACK_THREE_DEC,
  dynamicPricesForBatteryEnabled: false,
  priceLimitBattery: PRICE_FALLBACK_THREE_DEC,
  referencePrice: PRICE_FALLBACK_THREE_DEC,
  activeMonthsBattery: [],
  batteryStateOfChargeLimit: PRICE_FALLBACK_NO_DEC,
}

type DYNAMIC_AND_REFERENCE_PRICE_MODEL_TYPE = DynamicPricesModel & ReferencePriceModel
const MAX_STRING_LENGTH = 100

/**
 *  Initializes the form for DPP settings
 * @param model DynamicPricesSettings
 * @returns initialValues and validationSchema for DPP settings form
 */
export const useDPPSettingsFormFullFormInitializer = (
  model: DynamicPricesSettings | null
): FormInitializerReturnType<DYNAMIC_AND_REFERENCE_PRICE_MODEL_TYPE, DYNAMIC_AND_REFERENCE_PRICE_MODEL_TYPE> => {
  const { t } = useCustomTranslation()
  const numberFromStringSchemaWithTranslation = numberFromStringSchema(t)
  const initialValues = model ?? fallbackFormValues

  const validationSchema = object().shape({
    dynamicPricesForWallboxesEnabled: boolean().required(),
    priceLimitWallbox: numberFromStringSchemaWithTranslation().required(),
    dynamicPricesForBatteryEnabled: boolean(),
    isDynamicEmsEnabledForBattery: boolean(),
    priceLimitBattery: numberFromStringSchemaWithTranslation(),
    activeMonthsBattery: array().optional().of(number().required()),
    batteryStateOfChargeLimit: numberFromStringSchemaWithTranslation({ max: MAX_STRING_LENGTH }).required(),
    referencePrice: numberFromStringSchemaWithTranslation().required(),
    networkFees: numberFromStringSchemaWithTranslation().required(),
    energyPriceSurcharge: numberFromStringSchemaWithTranslation({ max: MAX_STRING_LENGTH }).required(),
    taxes: numberFromStringSchemaWithTranslation().required(),
  })

  return { initialValues, validationSchema }
}
